<script>
import {Link} from "@inertiajs/vue3";

export default {
  components: {Link},
  props: ['productId']
}
</script>

<template>
  <div class="d-flex flex-wrap gap-2 mb-4" v-if="$page.component !== 'products/create'">
    <div>
      <Link class="btn" :href="route('products.edit', {'product': productId})" :class="{
        'btn-primary': $page.component === 'products/edit',
        'btn-secondary': $page.component !== 'products/edit',
        'disabled': !productId
      }">
        Product
      </Link>
    </div>

    <div>
      <Link class="btn" :href="route('products.maintenance_histories.index', {'product': productId})" :class="{
        'btn-primary': $page.component === 'maintenance_histories/index',
        'btn-secondary': $page.component !== 'maintenance_histories/index',
        'disabled': !productId
      }">
        Onderhoudshistorie
      </Link>
    </div>

    <div>
      <Link class="btn" :href="route('products.inspection_reports.index', {product: productId})" :class="{
        'btn-primary': $page.component === 'product_inspection_reports/index',
        'btn-secondary': $page.component !== 'product_inspection_reports/index',
        'disabled': !productId
      }">
        Keuringsrapporten
      </Link>
    </div>
  </div>
</template>